import type { ReactElement } from "react";
import { PfMark } from "../../shell/Brand";
import { Icon } from "../../ui/Icon/Icon";
import { Button } from "../../ui/Button/Button";
import styles from "./CallbackScreen.module.css";

export interface CallbackScreenProps {
  // When set, the authorisation callback failed and this message is shown with
  // a way back to sign-in, instead of the in-progress state.
  error?: string | null;
}

export function CallbackScreen({
  error,
}: CallbackScreenProps = {}): ReactElement {
  if (error) {
    return (
      <div className={styles.screen}>
        <div className={styles.inner}>
          <span className={styles.errorMark} aria-hidden="true">
            <Icon name="alert" size={26} />
          </span>
          <h1 className={styles.title}>Sign-in couldn&apos;t be completed</h1>
          <p className={styles.text}>{error}</p>
          <Button
            variant="secondary"
            onClick={() => window.location.assign(import.meta.env.BASE_URL)}
          >
            Back to sign in
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.screen}>
      <div className={styles.inner}>
        <PfMark size={36} className={styles.mark} />
        <div className={styles.track}>
          <div className={styles.bar} />
        </div>
        <h1 className={styles.title}>Completing sign-in</h1>
        <p className={styles.text}>
          Verifying the authorisation code returned by Property Finder and
          starting your session.
        </p>
        <div className={styles.mono}>{"/app/callback?code=•••&state=•••"}</div>
      </div>
    </div>
  );
}
